import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import Category from "pages/category";
import Home from "pages/home/Home";
import About from "pages/about/About";
import Cart from "features/cart/Cart";
import ProductDetails from "features/productDetails";
import Login from "components/Login";
import Compare from "features/compare";
import ContactUs from "pages/contactUs/ContactUs";
import Gallery from "pages/gallery/Gallery";
import Accessories from "features/accessories/Accessories";
import GalleryItem from "features/galleryItem";
import AccessoryDetails from "features/accessoryDetailts";
import Unsubscribe from "pages/unsubscribe/Unsubscribe";
import Sitemap from "pages/sitemap/Sitemap";
import SearchPage from "pages/search/SearchPage";
import TermsAndConditions from "components/TermsAndConditions";
import Policy from "components/Policy";

const TopLevelRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/category" element={<Category />} />
      <Route path="/promotions" element={<Category />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/about-us" element={<About />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/product/:alias" element={<ProductDetails />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/gallery/:id" element={<GalleryItem />} />
      <Route path="/accessories" element={<Accessories />} />
      <Route path="/accessories/:id" element={<AccessoryDetails />} />
      <Route path="/asparuh" element={<Login />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/policy" element={<Policy />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default TopLevelRouter;
